import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { matchText } from 'modules/core/lib/stringUtils'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import type { Participant } from 'modules/surveys/lib/participant'
import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'

import BodyLayout from './BodyLayout'

const useFilter = createComputed(
  (
    participants: Participant[],
    accessGroup: AccessGroup,
    search: string,
    groupable_access_ids: string[]
  ) => {
    const isMemberStrategy = accessGroup.attributes.strategy === AccessGroup.Strategies.members

    if (isMemberStrategy) {
      const respondents_access_ids = formAccessGroupMemberships
        .filter({ access_group_id: accessGroup.attributes.id })
        .map((membership) => membership.attributes.access_id)

      return participants.filter(
        (p) => respondents_access_ids.includes(p.id) && matchText(search, p.fullName)
      )
    } else {
      return participants.filter(
        (p) => groupable_access_ids.includes(p.id) && matchText(search, p.fullName)
      )
    }
  }
)

interface Props {
  search: string
  accessGroup: AccessGroup
  participants: Participant[]
}

function Body({ search, accessGroup, participants }: Props) {
  const filteredParticipants = useFilter(
    participants,
    accessGroup,
    search,
    accessGroup.attributes.access_ids.map((id: string) => id)
  ).get()

  return <BodyLayout participants={filteredParticipants} />
}

export default observer(Body)
